import React, {useEffect, useState} from "react";
import {Box, Grid, MenuItem, Paper, Snackbar, Typography} from "@material-ui/core";
import {useConsumerContext} from "../../context/ConsumerContext";
import {MUIAutoComplete, MUIInput, MUISelect, MUISwitch} from "../../utils/formUtils";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as yup from "yup";
import {AVAILABLE_ACTIONS} from "../../utils/constants";
import axiosInstance from "../../api";
import Spinner from "../../components/Spinner";
import {Alert} from "@material-ui/lab";
import addressData from "../../data/addressData.json";
import {useHistory} from "react-router-dom";
import "yup-phone";
import {WizardNav} from "../../utils/fmapUtils";
import {ContactMailOutlined} from "@mui/icons-material";


const validationSchema = yup.object().shape({
    email: yup.string().email('Email should be in valid format').lowercase().required('Please complete all required fields').nullable(),
    emailCopy: yup.string().email('Email should be in valid format').lowercase().oneOf([yup.ref('email'), ''], 'Email must match').required('Please complete all required fields').nullable(),
    firstName: yup.string().required('Please complete all required fields').nullable(),
    lastName: yup.string().required('Please complete all required fields').nullable(),
    mobilePhone: yup.string().phone("US", false, "Primary phone must be a valid US phone number").required('Please complete all required fields').nullable(),
    referredBy: yup.string().required('Please complete all required fields').nullable(),
    mailingAddressLine1: yup.string().when('isMailingSameAsProperty', {
        is: (isMailingSameAsProperty) => isMailingSameAsProperty === false,
        then: yup.string().required('Please complete all required fields').nullable(),
        otherwise: yup.string().nullable()
    }),
    mailingCity: yup.string().when('isMailingSameAsProperty', {
        is: (isMailingSameAsProperty) => isMailingSameAsProperty === false,
        then: yup.string().required('Please complete all required fields').nullable(),
        otherwise: yup.string().nullable()
    }),
    mailingState: yup.string().when(['isMailingSameAsProperty', 'mailingCountry'], {
        is: (isMailingSameAsProperty, mailingCountry) => isMailingSameAsProperty === false && mailingCountry === "United States of America",
        then: yup.string().required('Please complete all required fields').nullable(),
        otherwise: yup.string().nullable()
    }),
    mailingZip: yup.string().when('isMailingSameAsProperty', {
        is: (isMailingSameAsProperty) => isMailingSameAsProperty === false,
        then: yup.string().required('Please complete all required fields').nullable(),
        otherwise: yup.string().nullable()
    }),
    mailingCountry: yup.string().when('isMailingSameAsProperty', {
        is: (isMailingSameAsProperty) => isMailingSameAsProperty === false,
        then: yup.string().required('Please complete all required fields').nullable(),
        otherwise: yup.string().nullable()
    }),
});
export default function UserDetails() {
    const history = useHistory();
    const {handleSubmit, control, formState: {errors}} = useForm({resolver: yupResolver(validationSchema)});
    const {consumerData, dispatch} = useConsumerContext();
    const [hasError, setHasError] = useState(false);
    const [showSpinner, setShowSpinner] = useState(false);
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [referralList, setReferralList] = useState([]);
    const [countryList, setCountryList] = useState([]);
    const [userEmailCopy, setUserEmailCopy] = useState('');
    const [snackBarSettings, setSnackBarSettings] = useState({show:false, message : '', variant:''});

    useEffect(() => {
        setReferralList(addressData.referralList);
        // let addrList = addressData.countryList.map(x => {return {label : x, value : x}});
        // console.error(addrList);
        setCountryList(addressData.countryList);
        dispatch({type: AVAILABLE_ACTIONS.UPDATE_ADDRESS, userRequest: {"userRequestStatus": "SUBMITTED"}});
    }, []);

    const onSubmit = data => {
        setShowSpinner(true);
        if (consumerData.isMailingSameAsProperty) {
            data["mailingAddressLine1"] = undefined;
            data["mailingAddressLine2"] = undefined;
            data["mailingCity"] = undefined;
            data["mailingState"] = undefined;
            data["mailingZip"] = undefined;
            data["mailingCountry"] = undefined;
        }
        data["userRequestId"] = consumerData?.userRequestId;
        data["userRequestStatus"] = "SUBMITTED";
        data["nonce"] = consumerData?.nonce;
        axiosInstance.post("unauth/leads/completeApplication", data)
            .then(response => {
                if (response === -100) {
                    setSnackBarSettings(Object.assign({},{show:true, message : 'An active property quote request already exists for this address. You can review your property quote request information and/or update the “need by” date for your request by selecting the link provided in your confirmation email or by using the “Search” button located on the Consumer page of the FMAP website. For additional assistance, please submit your question using Contact Us.', variant:'error'}));
                } else {
                    setFormSubmitted(true);
                    setHasError(false);
                    //dispatch({type: AVAILABLE_ACTIONS.INIT});
                    sessionStorage.removeItem("_consumerData");
                    sessionStorage.clear();
                    history.push("/confirm");
                }

            }).catch(e => {
            setHasError(true);
        }).finally(() => setShowSpinner(false));
    }

    function handleFormChange(event) {
        if (event?.target?.name === 'emailCopy') {
            setUserEmailCopy(event.target.value);
        } else {
            dispatch({
                type: AVAILABLE_ACTIONS.UPDATE_CONTACTINFO,
                userRequest: {[event.target.name]: event.target.value}
            });
        }
    }

    const handleFormChangeCheckbox = (event) => {
        dispatch({
            type: AVAILABLE_ACTIONS.UPDATE_CONTACTINFO,
            userRequest: {[event.target.name]: event.target.checked}
        });
    };

    function blockFieldCopy(event) {
        event.preventDefault();
    }

    const handleSnackBarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackBarSettings(Object.assign({},{show:false, message : '', variant:''}));
    }


    // spinner
    if (showSpinner) return <Spinner/>;


    return (
        <section>

            <Typography variant="h4" align="left" component="h4" gutterBottom
                        style={{paddingLeft: 24, fontWeight: 600}}>
                Contact Details <ContactMailOutlined/>
            </Typography>


            {!formSubmitted &&
            <form
                onSubmit={handleSubmit(onSubmit)}>
                <Box m={3} marginTop={0}>
                    <Typography variant="h6" align="left" component="h6" gutterBottom style={{marginBottom: 16}}>
                        Enter your name, a valid email and phone numbers. Your information is provided to participating
                        agents interested in helping you find coverage for your home once you are registered.
                    </Typography>


                    <Paper style={{padding: 16}}>
                        <Typography variant="h5" component="h2" style={{paddingLeft: 8, marginBottom: 8}}>
                            Contact Details
                        </Typography>
                        <Box style={{padding: 16}}>
                            <Grid container alignItems="flex-start" spacing={2}>
                                <Grid item xs={12} sm={6} md={4}>
                                    <MUIInput control={control} name="firstName"
                                              defaultValue={consumerData?.firstName} inputPrp={{maxLength: 100}}
                                              value={consumerData?.firstName} label="First Name"
                                              onInputChange={handleFormChange} errors={errors}/>
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <MUIInput control={control} name="lastName"
                                              defaultValue={consumerData?.lastName} inputPrp={{maxLength: 100}}
                                              value={consumerData?.lastName} label="Last Name"
                                              onInputChange={handleFormChange} errors={errors}/>
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <MUIInput control={control} name="email" onInputCopy={blockFieldCopy}
                                              onInputCut={blockFieldCopy}
                                              defaultValue={consumerData?.email} inputPrp={{maxLength: 50}}
                                              value={consumerData?.email} label="Email"
                                              onInputChange={handleFormChange} errors={errors}/>
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <MUIInput control={control} name="emailCopy" inputPrp={{maxLength: 50}}
                                              onInputPaste={blockFieldCopy}
                                              defaultValue={userEmailCopy}
                                              value={userEmailCopy} label="Reenter Email"
                                              onInputChange={handleFormChange} errors={errors}/>
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <MUIInput control={control} name="mobilePhone"
                                              defaultValue={consumerData?.mobilePhone} inputPrp={{maxLength: 10}}
                                              value={consumerData?.mobilePhone} label="Primary Phone"
                                              onInputChange={handleFormChange} errors={errors}/>
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <MUIInput control={control} name="altPhone"
                                              defaultValue={consumerData?.altPhone} inputPrp={{maxLength: 10}}
                                              value={consumerData?.altPhone} label="Alternate Phone Number"
                                              onInputChange={handleFormChange} errors={errors}/>
                                </Grid>

                                <Grid item xs={12} sm={6} md={4}>
                                    <MUISelect id="referredBy" control={control} name="referredBy" label="Referred By"
                                               errors={errors}
                                               value={consumerData?.referredBy}
                                               onFormChange={handleFormChange} required="true"
                                               defaultValue={consumerData?.referredBy}>
                                        {referralList.map(r => {
                                            return <MenuItem key={r} value={r}>{r}</MenuItem>
                                        })}
                                    </MUISelect>
                                </Grid>
                            </Grid></Box>
                    </Paper><br/>
                    <Paper style={{padding: 16}}>
                        <Typography variant="h5" component="h2" style={{paddingLeft: 8, marginBottom: 8}}>
                            Mailing Address
                        </Typography>
                        <Box style={{padding: 16}}>
                            <Grid container alignItems="flex-start" spacing={2}>
                                <Grid item xs={12} sm={6} md={4}>
                                    <MUISwitch label="Is Mailing Address Same as Property Address?" errors={errors}
                                               defaultValue={consumerData?.isMailingSameAsProperty}
                                               value={consumerData?.isMailingSameAsProperty}
                                               name="isMailingSameAsProperty"
                                               control={control} onChecked={handleFormChangeCheckbox}></MUISwitch>
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}></Grid>
                                <Grid item xs={12} sm={6} md={4}></Grid>
                                {!consumerData?.isMailingSameAsProperty &&
                                <>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <MUIInput control={control} name="mailingAddressLine1"
                                                  inputPrp={{maxLength: 80}}
                                                  defaultValue={consumerData?.mailingAddressLine1}
                                                  value={consumerData?.mailingAddressLine1} label="Address Line 1"
                                                  onInputChange={handleFormChange} errors={errors}/>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <MUIInput control={control} name="mailingAddressLine2"
                                                  inputPrp={{maxLength: 80}}
                                                  defaultValue={consumerData?.mailingAddressLine2}
                                                  value={consumerData?.mailingAddressLine2} label="Address Line 2"
                                                  onInputChange={handleFormChange} errors={errors}></MUIInput>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <MUIInput control={control} name="mailingCity" inputPrp={{maxLength: 50}}
                                                  defaultValue={consumerData?.mailingCity}
                                                  value={consumerData?.mailingCity} label="City"
                                                  onInputChange={handleFormChange} errors={errors}></MUIInput>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <MUIInput control={control} name="mailingState" inputPrp={{maxLength: 50}}
                                                  defaultValue={consumerData?.mailingState}
                                                  value={consumerData?.mailingState} label="State"
                                                  onInputChange={handleFormChange} errors={errors}></MUIInput>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <MUIInput control={control} name="mailingZip" inputPrp={{maxLength: 20}}
                                                  defaultValue={consumerData?.mailingZip}
                                                  value={consumerData?.mailingZip} label="Zip/ Postal Code"
                                                  onInputChange={handleFormChange} errors={errors}></MUIInput>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <MUIAutoComplete control={control} name="mailingCountry" options={countryList}
                                                         inputStateLabel="mailingCountryInputValue"
                                                         label="Country"
                                                         inputStateValue={consumerData?.mailingCountryInputValue}
                                                         value={consumerData?.mailingCountry}
                                                         onValueChange={handleFormChange}
                                                         errors={errors}></MUIAutoComplete>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}></Grid>
                                    <Grid item xs={12} sm={6} md={4}></Grid>
                                </>
                                }
                                <Grid item xs={12}>
                                    {hasError && <div>
                                        <br/>
                                        <Alert variant="filled" severity="error">An error occurred. Please try again later.</Alert>
                                    </div>}
                                </Grid>
                            </Grid></Box>
                    </Paper>

                </Box>
                <WizardNav currentStep={consumerData?.wizardStep}
                           handleBackClick={() => dispatch({type: AVAILABLE_ACTIONS.MOVE_NEXT, wizardStep: 4})}/>
            </form>
            }
            <Snackbar open={snackBarSettings.show} autoHideDuration={6000} onClose={handleSnackBarClose}>
                <Alert variant="filled" onClose={handleSnackBarClose}
                       severity={snackBarSettings.variant}>{snackBarSettings.message}</Alert>
            </Snackbar>
        </section>
    );
}
